import { useQuery } from '@tanstack/react-query'
import { freeTitlesApi } from '@!/Api/storeBook'
import { freeTitlesKeys } from '@!/Api/queryKeys'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useFreeTitles = (genreTabName, page, fetchType = null) => {
  const [safeSearch] = useAtom(safeSearchAtom)
  return useQuery({
    queryKey: freeTitlesKeys.free_titles(genreTabName, page, fetchType),
    queryFn: async () => {
      return await freeTitlesApi(genreTabName, page, fetchType)
    },
    // セーフサーチが有効な場合、TL・BLジャンルの無料タイトルを取得しない
    enabled: !(safeSearch && (genreTabName === 'tl' || genreTabName === 'bl')),
    keepPreviousData: true,
  })
}
